// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"09e205b6","197":"80769cb5","390":"7451eb24","406":"7d0b88a6","654":"cc414738","753":"ba3660e4","884":"9413149b"}[chunkId] + ".chunk.js";
};